module.exports = __webpack_public_path__ + "img/co.d61690e5.svg";